import type { ReactNode } from 'react'

export const labelText = (node: ReactNode): string => {
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(labelText).join('')
  if (node && typeof node === 'object' && 'props' in (node as { props?: unknown })) {
    const props = (node as { props?: { children?: ReactNode } }).props
    if (props?.children !== undefined) return labelText(props.children)
  }
  return ''
}
